const translationsLocations = {
  'de-DE': {
    today: 'Heute',
    tomorrow: 'Morgen',
  },
  'de-AT': {
    today: 'Heute',
    tomorrow: 'Morgen',
  },
  'de-CH': {
    today: 'Heute',
    tomorrow: 'Morgen',
  },
  'en-GB': {
    today: 'Today',
    tomorrow: 'Tomorrow',
  },
  'pt-PT': {
    today: 'Hoje',
    tomorrow: 'Amanhã',
  },
  es: {
    today: 'Hoy',
    tomorrow: 'Mañana',
  },
  fr: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
  },
  it: {
    today: 'Oggi',
    tomorrow: 'Domani',
  },
  se: {
    today: 'Idag',
    tomorrow: 'I morgon',
  },
  nl: {
    today: 'Vandaag',
    tomorrow: 'Morgen',
  },
  pl: {
    today: 'Dzisiaj',
    tomorrow: 'Jutro',
  },
};

module.exports = translationsLocations;
